export const FINANCE_JOURNEY = 'buy_online_finance';
export const CASH_JOURNEY = 'buy_online_cash';
